/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RenderedBoxChildrenInner } from './RenderedBoxChildrenInner';
import {
    RenderedBoxChildrenInnerFromJSON,
    RenderedBoxChildrenInnerFromJSONTyped,
    RenderedBoxChildrenInnerToJSON,
    RenderedBoxChildrenInnerToJSONTyped,
} from './RenderedBoxChildrenInner';

/**
 * Layout container mirroring the core-ui Box component (rendered side).
 * @export
 * @interface RenderedBox
 */
export interface RenderedBox {
    /**
     * 
     * @type {string}
     * @memberof RenderedBox
     */
    type?: RenderedBoxTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof RenderedBox
     */
    title?: string | null;
    /**
     * core-ui Box props / CSS style properties (e.g. flexBasis, minWidth)
     * @type {{ [key: string]: any; }}
     * @memberof RenderedBox
     */
    cssProperties?: { [key: string]: any; };
    /**
     * Nested rendered nodes
     * @type {Array<RenderedBoxChildrenInner>}
     * @memberof RenderedBox
     */
    children?: Array<RenderedBoxChildrenInner>;
}


/**
 * @export
 */
export const RenderedBoxTypeEnum = {
    Box: 'Box'
} as const;
export type RenderedBoxTypeEnum = typeof RenderedBoxTypeEnum[keyof typeof RenderedBoxTypeEnum];


/**
 * Check if a given object implements the RenderedBox interface.
 */
export function instanceOfRenderedBox(value: object): value is RenderedBox {
    return true;
}

export function RenderedBoxFromJSON(json: any): RenderedBox {
    return RenderedBoxFromJSONTyped(json, false);
}

export function RenderedBoxFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenderedBox {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'cssProperties': json['cssProperties'] == null ? undefined : json['cssProperties'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(RenderedBoxChildrenInnerFromJSON)),
    };
}

export function RenderedBoxToJSON(json: any): RenderedBox {
    return RenderedBoxToJSONTyped(json, false);
}

export function RenderedBoxToJSONTyped(value?: RenderedBox | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'cssProperties': value['cssProperties'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(RenderedBoxChildrenInnerToJSON)),
    };
}

